export default class Dictionary<T> {
    [index: string]: T;
}